module.exports = __webpack_public_path__ + "img/buddy_whiskers-06.c8509759.svg";